/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  position: relative;
  text-align: left;
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
  font-size: 1rem;
  font-weight: 700;
  background: #FFFFFF;
  background: var(--davinci-color-background, #FFFFFF);
  display: block;
  padding: 0 calc(16rem /14);
}

.item-list {
  position: absolute;
  white-space: nowrap;
  box-shadow: 0 0 calc(3rem /14) rgba(0, 0, 0, 0.3);
  z-index: 8;
  right: calc(100% + calc(2rem /14));
  top: calc(5rem /14);
  background: #FFFFFF;
  background: var(--davinci-color-background, #FFFFFF);
}

.spacing-wrapper {
  padding: calc(16rem /14) 0;
  border-bottom: calc(1rem /14) solid transparent;
  border-color: #B1B8BC;
  border-color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([last]) .spacing-wrapper {
  border-bottom: none;
}

.label {
  flex-grow: 2;
  line-height: calc(16rem /14);
}
.label:not(.disabled):hover {
  cursor: pointer;
}
.label:not(.disabled):hover, .label:not(.disabled).active {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
.label.disabled {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
.label.disabled:hover {
  cursor: not-allowed;
}`;
export { style };
